import { render } from "./DeveloperCellText.vue?vue&type=template&id=5479441a"
import script from "./DeveloperCellText.vue?vue&type=script&lang=js"
export * from "./DeveloperCellText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__